<template>
    <a-upload
        :file-list="fileList
       "
        list-type="picture-card"
        name="image"
        :multiple="true"
        :custom-request="handleUpload"
        :on-remove="handleRemove"
    >
        <div>
            <plus-outlined />
            <div style="margin-top:8px; font-size:16px">Upload</div>
            <div style="font-size:10px; color:grey">Clique ou arraste para enviar</div>
        </div>
    </a-upload>
</template>

<script setup>
import {ref, defineProps, onMounted} from 'vue'
import {PlusOutlined} from '@ant-design/icons-vue'
import {notification} from "ant-design-vue";
import { openNotification } from '../../../../../../utils/utilities';

const props = defineProps({
    subdivisionPropertyId: Number,
})

const fileList = ref([]);

onMounted(async () => {
    try {
        await loadFiles()
    } catch (error) {
        openNotification('error', error)
    }
})

const handleUpload = async file => {
    try {
        const formData = new FormData()
        formData.append('subdivisionPropertyId', props.subdivisionPropertyId)
        formData.append('file', file.file)

        const response = (await window.axios.post('/api/map-actions/bic/subdivision-files', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        })).data.data

        const listFile = {
            uid: file.uid,
            name: response,
            status: 'done',
            url: `/storage/bic_subdivisions_files/${response}`
        }

        fileList.value.push(listFile)

        openNotification('success', 'Imagem salva com sucesso')
    } catch (error) {
        openNotification('error', 'Erro ao salvar imagem')
    }
}

const handleRemove = async file => {
    await window.axios.delete(`/api/map-actions/bic/subdivision-files/${props.subdivisionPropertyId}`, { data: { name: file.name }})
    await loadFiles()
}
const loadFiles = async () => fileList.value = (await window.axios.get(`/api/map-actions/bic/subdivision-files/${props.subdivisionPropertyId}`)).data.data
</script>

<style scoped>
::v-deep(.ant-upload.ant-upload-drag) {

    height: auto !important;
    min-height: auto !important;
    padding: 8px;
}


::v-deep(.anticon.anticon-eye) {
    display: inline !important;
}

::v-deep(.ant-upload-list-item-container), ::v-deep(.ant-upload) {
    width: 120px !important;
    height: 120px !important;
}
</style>